import { NgModule } from '@angular/core';

import { HisUiService, HisGenericValueService, HisConfirmationService } from 'hisng';

import { NominationService } from 'app/fs/res/prize-nomination/nomination/service/nomination.service';
import { PublicationSharedModule } from './publication-shared.module';
import { GlobalIdentifierTypeService } from './service/types.service';
import { PublicationService } from './service/publication.service';
import { JournalService } from './service/journal.service';
import { OrcidImportService } from './service/orcid-import.service';
import { BibtexImportService } from './service/bibtex-import.service';
import { StateService } from '../common/service/core/state.service';
import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';
import { ResearchPartnerService } from 'app/fs/res/common/service/researchPartner/researchPartner.service';
import { PublisherService } from './service/publisher.service';
import { ProjectService } from '../finance/service/project/project.service';
import { PublicationRoutesModule } from './publication.routes';
import { PersonService } from 'app/fs/res/common/service/person/person.service';
import { PublicationAuthService } from './service/publication-auth.service';
import { ConferenceService } from './service/conference.service';
import { ConferenceAuthService } from './service/conference-auth.service';
import { RepositoryImportService } from './service/repository-import.service';
import { PublicationTypeRelationService } from './service/publication-type-relation.service';
import { ResearchInfrastructureService } from '../research-infrastructure/service/research-infrastructure.service';
import { PublicationImportService } from './service/publication-import.service';
import { PublicationDocumentMetadataService } from './service/publication-document-metadata.service';

/**
 * CoreModule for publications.
 */
@NgModule( {
    imports: [
        PublicationSharedModule,
        PublicationRoutesModule
    ],
    declarations: [],
    exports: [PublicationSharedModule],
    providers: [
        PublicationService,
        JournalService,
        ConferenceService,
        ConferenceAuthService,
        OrcidImportService,
        BibtexImportService,
        PublicationImportService,
        RepositoryImportService,
        PublisherService,
        HisGenericValueService,
        HisConfirmationService,
        GlobalIdentifierTypeService,
        HisUiService,
        ProjectService,
        StateService,
        NominationService,
        OrganizationService,
        ResearchPartnerService,
        PublicationAuthService,
        PersonService,
        PublicationTypeRelationService,
        ResearchInfrastructureService,
        PublicationDocumentMetadataService
    ],
} )

export class PublicationCoreModule {
}
